import { useLayoutEffect } from 'react';

import { KTUtil } from '_metronic/_assets/js/components/util';
import KTLayoutScrolltop from '_metronic/_assets/js/layout/extended/scrolltop';

export function LayoutInit() {
  useLayoutEffect(() => {
    KTUtil.ready(function () {
      KTLayoutScrolltop.init('kt_scrolltop');
    });
  }, []);
  return <></>;
}
